import { NdSklad } from '../../ndSklad';

export { DMS_MODULE, MODULE_API } from '../../constants';
export const NAME = <const>'NdPrijemkaPolozky';
export const CRUMB_LABEL_KEY = 'edtNDPrijemka';
export const ND_SKLAD = NdSklad.name;
